import { render, staticRenderFns } from "./GetSameWindow.vue?vue&type=template&id=bef1e5c4&scoped=true&"
import script from "./GetSameWindow.vue?vue&type=script&lang=js&"
export * from "./GetSameWindow.vue?vue&type=script&lang=js&"
import style0 from "./GetSameWindow.vue?vue&type=style&index=0&id=bef1e5c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef1e5c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VRow})
